<template>
  <ul>
    <li
      v-for="(a, index) in buyFlowStore.getOrderedAdjustmentsToDisplay(props.adjustments)"
      :id="`adjustmentItem-${index}`"
      :key="a.type"
      :class="a.textClass"
      class="opposite-ends"
    >
      <div>
        <span class="">{{ t(`Adjustments.${a.type}`, { replacementText: a.textReplacement }) }}</span>
      </div>
      <div v-if="a.amountText" class="amount no-shrink text-center">
        <span :id="`adjustment-amount-${a.type}`">{{ a.amountText }}</span>
      </div>
      <div v-else class="amount">
        <span :id="`adjustment-amount-${a.type}`">{{ formatMoney(a.amount || 0) }}</span>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { t } from "@/i18n";
import { formatMoney } from "@/components/Buy/commonFn";
import { useBuyFlowStore } from "@/stores/buyFlow";
import { PropType } from "vue";
import { IAdjustment } from "@/common/api/unifiedPortal/interfaces";
import { logEvent } from "@/common/logger";

const componentName = "AdjustmentsComponent";

logEvent("created", componentName);

const buyFlowStore = useBuyFlowStore();
const props = defineProps({
  adjustments: {
    type: Object as PropType<IAdjustment[]>,
    required: true,
  },
});
</script>
